import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { NavAddCircle } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button } from '@va/ui/design-system';
import { useDispatch } from 'react-redux';

type UpgradeButtonProps = {
  label?: string;
  disabled?: boolean;
  tooltip?: string;
};

export const UpgradeButton = ({ label, disabled, tooltip }: UpgradeButtonProps) => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  return (
    <Button
      disabled={disabled}
      tooltip={tooltip}
      icon={(_, color) => <NavAddCircle color={color} />}
      text={label ?? translate('button.upgradePlan')}
      className='!bg-white !hover:bg-white-light justify-center font-medium w-full mt-3'
      color='tertiary'
      onClick={() => {
        dispatch(startUpgradeProcess());
      }}
    />
  );
};
